import merge from 'lodash/merge'
import baseStyles from '../Base/Base.styles'

export default ({
  base,
}) => {
  
  const jss = {
    root: {
      ...baseStyles(base)
    }
  }

  merge(jss, { 
    root: { 
      '& .wrapper': {
        borderWidth: 'var(--themeBorderThickness)',
        borderRadius: 'var(--themeShape)',
        borderColor: 'var(--color-greyLight)',
        padding: '20px'
      },
      '& .confirmCustomer': {
        paddingBottom: '20px'
      },
      '& .order-items-header': {
        paddingTop: '20px'
      },
      '& .order-items': {
        paddingTop: '20px'
      },
      '& .order-items-list': {
        paddingTop: '20px',
        paddingBottom: '20px',
        borderWidth: '1px',
        borderRadius: '4px',
        borderColor: 'var(--color-greyLight)',
        padding: '20px'
      }
    }
  })

  return jss

}